"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _composeUpdatedValues = _interopRequireDefault(require("../../../helpers/composeUpdatedValues.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {} : _ref$validate,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? [] : _ref$fields;
  var arrayName = (fields[0] || 'some').replace(/\[.*$/, '');
  return function (WrappedComponent) {
    var _Component, _Component2;
    var ReduxForm = (0, _reduxForm.reduxForm)()((_Component = /*#__PURE__*/function (_React$Component) {
      function Component() {
        _classCallCheck(this, Component);
        return _callSuper(this, Component, arguments);
      }
      _inherits(Component, _React$Component);
      return _createClass(Component, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props = this.props,
            valid = _this$props.valid,
            values = _this$props.values,
            field = _this$props.field;
          if (!valid || prevProps.values === values) {
            return;
          }
          try {
            field.onChange((0, _composeUpdatedValues["default"])(field.value, values));
          } catch (e) {
            console.error('Update has failed:');
            console.error(e);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
            field = _this$props2.field,
            originalProps = _this$props2.originalProps,
            setPath = _this$props2.setPath,
            onUpdateSettings = _this$props2.onUpdateSettings;
          return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
            fields: this.props.fields,
            setPath: setPath,
            Link: this.props.Link,
            settings: field.value,
            updateSettings: onUpdateSettings
          }, originalProps));
        }
      }]);
    }(_react["default"].Component), _defineProperty(_Component, "propTypes", {
      field: _propTypes["default"].object,
      fields: _propTypes["default"].object,
      values: _propTypes["default"].object,
      valid: _propTypes["default"].bool,
      setPath: _propTypes["default"].func,
      onUpdateSettings: _propTypes["default"].func,
      originalProps: _propTypes["default"].object
    }), _Component));
    return _Component2 = /*#__PURE__*/function (_React$Component2) {
      function Component() {
        var _this;
        _classCallCheck(this, Component);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _callSuper(this, Component, [].concat(args));
        _defineProperty(_this, "getLinkComponent", function () {
          return function (_ref2) {
            var path = _ref2.path,
              children = _ref2.children;
            return /*#__PURE__*/_react["default"].createElement("a", {
              href: "",
              onClick: function onClick(e) {
                e.preventDefault();
                _this.props.setPath(path);
              }
            }, children);
          };
        });
        return _this;
      }
      _inherits(Component, _React$Component2);
      return _createClass(Component, [{
        key: "render",
        value: function render() {
          var originalProps = (0, _omit2["default"])(this.props, ['setPath', 'field', 'onUpdateSettings']);
          if (fields.length === 0) {
            return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
              setPath: this.props.setPath,
              Link: this.getLinkComponent(),
              settings: this.props.field.value,
              updateSettings: this.props.onUpdateSettings
            }, originalProps));
          }
          var initialValues = (0, _isArray2["default"])(this.props.field.value) ? _defineProperty({}, arrayName, this.props.field.value) : this.props.field.value;
          return /*#__PURE__*/_react["default"].createElement(ReduxForm, {
            form: this.props.field.name || 'form',
            initialValues: initialValues,
            onSubmit: function onSubmit() {},
            field: this.props.field,
            setPath: this.props.setPath,
            fields: fields,
            validate: validate,
            onUpdateSettings: this.props.onUpdateSettings,
            Link: this.getLinkComponent(),
            originalProps: originalProps
          });
        }
      }]);
    }(_react["default"].Component), _defineProperty(_Component2, "propTypes", {
      setPath: _propTypes["default"].func,
      field: _propTypes["default"].object
    }), _defineProperty(_Component2, "defaultProps", {
      field: {}
    }), _Component2;
  };
};